import React from 'react'
import hasFilter from '../hoc/hasFilter';
import queryString from 'query-string'
import getMomentNow from '../functions/getMomentNow';
import setMomentDateObjZero from '../functions/setMomentDateObjZero';
import filterPerformancesDateFilter from '../functions/filterPerformancesDateFilter';
import filterPerformancesQueryStringValues from '../functions/filterPerformancesQueryStringValues';
import { MULTICINEMA } from '../constants/multiCinemaModes';
import getMomentDateObj from '../functions/getMomentDateObj';
import isCurrentPerformance from '../functions/isCurrentPerformance';
import CinemaIcon from '../BackgroundFormatItem/CinemaIcon';
import PageOverviewSignageMovie from './PageOverviewSignageMovie';

const PageOverviewSignage = ({
    movies,
    cliData,
    cinemas,
    theme,
    match,
    translation,
    cinemaDataFront,
    dayFilters
}) => {
    const {signageParams} = match.params
    const {currentCinemaId} = cliData
    const {
        attribute_styling, 
        hidden_attributes, 
    } = cinemaDataFront
    const {theme_colors} = theme
    const signageParamsObj = queryString.parse(signageParams)
    const { timezone, locale } = translation
    const today = setMomentDateObjZero(getMomentNow(timezone))
    const currentCinema = currentCinemaId ? cinemas[currentCinemaId] : null
    const currentCinemaType = currentCinema ? currentCinema.scope.type : null
    const signageParamsCinema = signageParamsObj.cinema ? cinemas[signageParamsObj.cinema] : currentCinema
    let relevantMoviesArr
    let relevantMovies = {}
    let relevantCinemas = []
    let relevantMoviesPerformances = {}

    if(signageParamsCinema && signageParamsCinema.scope.type === MULTICINEMA) {
        relevantCinemas = signageParamsCinema.scope.cinemas
    } else {
        relevantCinemas.push(signageParamsCinema.pk)
    }
    
    relevantMoviesArr =_.keys(movies).filter(moviePk => {
        const movie = movies[moviePk]
        let movieIsRelevant = true
        const { performances, fsk, genres } = movie

        let purchaseblePerformances = _.filter(performances, performance => {
            const {limitations} = performance

            if(limitations.visibleFrom) {
                const performanceDate = getMomentDateObj(limitations.visibleFrom, timezone)

                return getMomentNow(timezone).isAfter(performanceDate)
            } else {
                return true
            }
        })

        let cinemaFilteredPerformances = purchaseblePerformances
        
        if(currentCinemaType === MULTICINEMA && signageParamsObj.cinema) {
            cinemaFilteredPerformances = _.filter(purchaseblePerformances, performance => {
                const performanceDate = getMomentDateObj(performance.timeUtc, timezone)
                if(isCurrentPerformance(today, performanceDate)) {
                    return performance.cinema === signageParamsObj.cinema
                }
            })
        }

        let timefilteredPerformance = signageParamsObj ? filterPerformancesDateFilter(cinemaFilteredPerformances, signageParamsObj, today, timezone, dayFilters, locale, false) : cinemaFilteredPerformances
        let fullyfilteredPerformance = signageParamsObj ? filterPerformancesQueryStringValues(timefilteredPerformance, signageParamsObj, false, null, null, null) : timefilteredPerformance

        if(fullyfilteredPerformance.length !== 0) {
            relevantMoviesPerformances[moviePk] = fullyfilteredPerformance
        }

        if(signageParamsObj.fsk) {
            movieIsRelevant = fsk && fsk.toString() === signageParamsObj.fsk 
        }
        
        if(signageParamsObj.genres) {
            movieIsRelevant = _.contains(genres, signageParamsObj.genres) 
        }

        return fullyfilteredPerformance.length !== 0 && movieIsRelevant
    })

    if(relevantMoviesArr) {
        relevantMoviesArr.map(moviePk => {
            relevantMovies[moviePk] = movies[moviePk]
        })
    }
    
    return (
        <div className='signage-page'>
            <div className='signage-header-wrapper'>
                <div className="logo-wrapper">
                    <div className="site-title site-logo">
                        <div className='logo-image'>
                            <span className="screen-reader-text">{signageParamsCinema.nameDisplay}</span>
                        </div>
                    </div>
                </div>
                {signageParamsObj.title && <h2 className='signage-title text-xlarge-medium'>{signageParamsObj.title}</h2>}
                {relevantCinemas.length !== 0 && 
                    <div className='cinemas-icon-wrapper'>
                        {relevantCinemas.map((cinemaPk, index) => {
                            return <CinemaIcon cinemaData={cinemas[cinemaPk]} key={index} />
                        })}
                    </div>
                }
            </div>
            <div className='signage-movies'>
                {!_.isEmpty(relevantMovies) && _.keys(relevantMovies).map((moviePk, index) => {
                    const movie = relevantMovies[moviePk]
                    const filteredPerformaces = relevantMoviesPerformances[moviePk]
                    return <PageOverviewSignageMovie
                        itemData={movie}
                        today={today}
                        attributeStyling={attribute_styling}
                        translation={translation}
                        filteredPerformaces={filteredPerformaces}
                        key={index}
                        hiddenAttributes={hidden_attributes}
                        queryStringValues={signageParamsObj}
                        theme={theme_colors}
                        currentCinema={currentCinema}
                        cinemas={cinemas}
                    />
                })}
            </div>
        </div>
    )
}

export default hasFilter(PageOverviewSignage)

